import { $get } from '../axios';

// 收益首页-收益明细列表/收益详情页-每日账单列表
export const getIncomeDayList = params => {
  return $get('/creator/', { act: 'get_sygl_day', ...params });
};
// 收益详情页-账单详情列表
export const getIncomeBillList = params => {
  return $get('/creator/', { act: 'get_sygl_details', ...params });
};
// 收益详情页-下载收益详情
export const exportBillData = params => {
  return $get('/creator/', { act: 'export_sygl_details', ...params });
};
// 收益详情页-下载每日账单
export const exportDayData = params => {
  return $get('/creator/', { act: 'export_sygl_day', ...params });
};
// 收益详情页-作品累计收益列表
export const getIncomeWorkList = params => {
  return $get('/creator/', { act: 'get_sygl_product', ...params });
};
// 收益首页概览
export const getIncomeOverview = params => {
  return $get('/creator/', { act: 'get_sygl_overview', ...params });
};
// 收益首页卡片
export const getIncomeCard = params => {
  return $get('/creator/', { act: 'get_sygl_card', ...params });
};
//获取收益折线图数据
export const getIncomeDiagram = params => {
  return $get('/creator/', { act: 'get_sygl_diagram', ...params });
};
// 收益提现
export const withdraw = params => {
  return $get('/creator/', { act: 'withdrawal', ...params });
};
// 结算首页概览
export const getSettlementOverview = params => {
  return $get('/creator/', { act: 'get_jszx_overview', ...params });
};
// 结算首页查询绑卡信息
export const getBankInfo = params => {
  return $get('/creator/', { act: 'get_bank_info', ...params });
};
// 结算提现记录列表
export const getRecordList = params => {
  return $get('/creator/', { act: 'get_jszx_bill', ...params });
};
// 结算提现记录详情
export const getRecordDetail = params => {
  return $get('/creator/', { act: 'get_jszx_bill_details', ...params });
};
// 查询银行卡所属名称
export const getBankName = params => {
  return $get('/creator/', { act: 'query_bank_name', ...params });
};
// 获取绑定银行卡的验证码
export const getBankVercode = params => {
  return $get('/creator/', { act: 'get_bank_vercode', ...params });
};
// 绑定银行卡
export const bindBank = params => {
  return $get('/creator/', { act: 'bind_bank', ...params });
};
//下载收入数据
export const exportIncome = params => {
  return $get('/creator/', { act: 'export_sygl_day', ...params });
};
//收益数据-作品收入数据
export const getProductIncome = params => {
  return $get('/creator/', { act: 'get_sygl_product', ...params });
};
//收益数据-下载作品收入数据
export const exportProIncome = params => {
  return $get('/creator/', { act: 'export_sygl_product', ...params });
};
//下载作品详情收入数据
export const fetchProductData = params => {
  return $get('/creator/', { act: 'export_map_income', ...params });
};
export const getDetailData = params => {
  return $get('/creator/', { act: 'get_map_income', ...params });
};
// 获取地图数据-地图详情-订单查询
export const getOrderGoodsData = params => {
  console.log('params', params);
  return $get('/creator/', { act: 'get_map_shop_order', ...params });
};
// 获取地图数据-地图详情-订单查询(下载)
export const fetchOrderGoodsData = params => {
  return $get('/creator/', { act: 'export_map_shop_order', ...params });
};
// 获取地图数据-地图详情-商品收益
export const getMapIncome = params => {
  return $get('/creator/', { act: 'get_map_shop_income', ...params });
};
// 获取地图数据-地图详情-商品收益导出
export const fetchMapIncome = params => {
  return $get('/creator/', { act: 'export_map_shop_income', ...params });
};
//个人结算中心-收益概览
export const fetchIncomeView = params => {
  return $get('/creator/', { act: 'get_jszx_overview', ...params });
};
//工作室结算中心-对公结算
export const fetchSettleData = params => {
  return $get('/creator/', { act: 'get_jszx_billing', ...params });
};
//工作室结算中心-下载结算单
export const fetchOverview = params => {
  return $get('/creator/', { act: 'invoice_down', ...params });
};
//工作室结算中心-点击订单完成
export const fetchBillOk = params => {
  return $get('/creator/', { act: 'bill_ok', ...params });
};
//工作室结算中心-重新发起流程
export const fetchBillReset = params => {
  return $get('/creator/', { act: 'bill_reset', ...params });
};
//工作室结算中心-邮寄发票
export const fetchBillSend = params => {
  return $get('/creator/', { act: 'invoice_report', ...params });
};
//工作室结算中心-查看明细
export const fetchBillIncome = params => {
  return $get('/creator/', { act: 'get_bill_income', ...params });
};
//个人结算中心-判断用户是否已看过个人结算中心fetchBrowse
export const fetchBrowse = params => {
  return $get('/creator/', { act: 'fetch_browse', ...params });
};
//个人结算中心-公告-查看明细
export const fetchBillDetail = params => {
  return $get('/creator/', { act: 'get_history_wallet', ...params });
};
//个人结算中心-记录结算一度状态
export const postNoticeFlag = params => {
  return $get('/creator/', { act: 'set_notice_flag', ...params });
};
